export enum TooltipName {
    CASINO_WELCOME,
    GUI_TIP,
}
